import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleMap, MapMarker, MapMarkerClusterer } from '@angular/google-maps';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../../misc.module';
import { PreviewPageRoutingModule } from './preview-routing.module';
import { ReportPreviewPageComponent } from './preview.page';

@NgModule({
  declarations: [ReportPreviewPageComponent],
  imports: [IonicModule, PreviewPageRoutingModule, MiscModule, CommonModule, GoogleMap, MapMarker, MapMarkerClusterer]
})
export class PreviewPageModule {}
